import { render, staticRenderFns } from "./LeaveCalendar.vue?vue&type=template&id=2befbdb9"
import script from "./LeaveCalendar.vue?vue&type=script&lang=js"
export * from "./LeaveCalendar.vue?vue&type=script&lang=js"
import style0 from "./LeaveCalendar.vue?vue&type=style&index=0&id=2befbdb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports